import React, { Component } from 'react';
import _ from 'lodash';
import { Form, Tabs } from 'antd';
import PropertyLayout from "./PropertyLayout";

const { TabPane } = Tabs;

export default class PropertyGallery extends Component {

    state = {
        galleries: []
    };

    source = null;

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.install(this.props.source);
    }

    componentWillUnmount() {
        if (this.source !== null) {
            this.uninstall(this.source);
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.source === this.props.source)
            return;

        this.install(nextProps.source);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.galleries !== this.state.galleries;
    }

    install(item) {

        if (this.source !== null) {
            this.uninstall(this.source);
        }

        if (!item || !item._) {
            this.setState({ galleries: [] });
            return;
        }

        this.source = item;

        const mapCatalogToGallery = {};
        const properties = [];
        for (const key in item._) {
            const value = item._[key];
            if (value.enabled === undefined || value.enabled) {
                value.name = key;
                properties.push(value);

                if (value.gallery && value.catalog && !mapCatalogToGallery[value.catalog])
                    mapCatalogToGallery[value.catalog] = value.gallery;
                else if (value.catalog && !value.gallery && mapCatalogToGallery[value.catalog])
                    value.gallery = mapCatalogToGallery[value.catalog];
            }
        }

        let group = _.groupBy(properties, c => c.gallery || "常规");
        let galleries = [];
        for (const name in group) {
            const items = group[name];
            galleries.push({ name, items });
        }

        galleries = _.sortBy(galleries, c => {
            let max = _.minBy(c.items, d => d.galleryIndex !== undefined ? d.galleryIndex : 999999999);
            return max.galleryIndex || 0;
        });

        galleries.forEach(g => {

            group = _.groupBy(g.items, c => c.catalog);
            let catalogs = [];
            for (const name in group) {
                const items = group[name];
                catalogs.push({ name, items });
            }

            catalogs = _.sortBy(catalogs, c => {
                let max = _.minBy(c.items, d => d.catalogIndex !== undefined ? d.catalogIndex : 999999999);
                return max.catalogIndex || 0;
            });

            g.catalogs = catalogs;
        });

        this.setState({ galleries });

        if (item && item._onPropertyGridBeginEdit)
            item._onPropertyGridBeginEdit();
    }

    uninstall(item) {
        if (this.unregisterPropertyChangedListener) {
            this.unregisterPropertyChangedListener();
            this.unregisterPropertyChangedListener = null;
        }

        if (item && item._onPropertyGridEndEdit)
            item._onPropertyGridEndEdit();
    }

    renderGallery() {
        if (!this.state.galleries || !this.state.galleries.length)
            return null;
        else if (this.state.galleries.length === 1)
            return <PropertyLayout catalogs={this.state.galleries[0].catalogs} propertyGrid={this.props.propertyGrid} formItemLayout={this.props.formItemLayout} showDescription={this.props.showDescription} orient={this.props.orient} />;
        else
            return (
                <Tabs className="fill" defaultActiveKey={this.state.galleries[0].name} animated={false}>
                    {
                        this.state.galleries.map((c, i) => (
                            <TabPane tab={c.name} key={c.name}>
                                <PropertyLayout catalogs={c.catalogs} propertyGrid={this.props.propertyGrid} formItemLayout={this.props.formItemLayout} showDescription={this.props.showDescription} orient={this.props.orient} />
                            </TabPane>
                        ))
                    }
                </Tabs>
            );
    }

    render() {

        return (
            <div className={"propertygrid-gallery fill layout-v vstretch" + (this.props.className || "")}  >
                {
                    this.renderGallery()
                }
            </div>
        );
    }
}
